import React from "react";

import { CommonSvgContent } from "./CommonSvgContent"
import { CommonContent } from "./CommonContent"

import "./../assets/scss/Footer.scss";

export const Footer = React.forwardRef((props, ref) => {
  const [archiveState, setArchiveState] = React.useState(0);

  const toggleArchiveContent = () => {
    if (archiveState === 0) setArchiveState(1);
    else setArchiveState(0);
  }

  return (
    <div className="footer" id="footer" ref={ref}>

      <div className="bigfooter">
        <div className="logoFoot">
          <CommonSvgContent stringToRet="logoMuseo" />
        </div>
        <p>
          <CommonContent stringToRet="address" lang={props.lang} />
          <a rel="noreferrer" target="_blank" href='https://www.museoscienza.org'>www.museoscienza.org</a><br />
        </p>

        <div className="socials">
          <a target="_blank" rel="noreferrer" href="https://www.facebook.com/museoscienza/"><CommonSvgContent stringToRet="facebook" /></a>
          <a target="_blank" rel="noreferrer" href="https://www.instagram.com/museoscienza/"><CommonSvgContent stringToRet="instagram" /></a>
          <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/museoscienza"><CommonSvgContent stringToRet="linkedin" /></a>
          <a target="_blank" rel="noreferrer" href="https://twitter.com/museoscienza/"><CommonSvgContent stringToRet="twitter" /></a>
          <a target="_blank" rel="noreferrer" href="https://www.youtube.com/museoscienza"><CommonSvgContent stringToRet="youtube" /></a>
        </div>

      </div>

      <div className="smallfooter">
        <div className="footleft">
          <p className="copyright">©2022 Museoscienza</p> | <a rel="noreferrer" target="_blank" href="https://www.museoscienza.org/it/privacy-policy">Privacy Policy</a> | <a rel="noreferrer" target="_blank" href="https://www.museoscienza.org/it/cookie-policy">Cookie Policy</a>
        </div>
        {/*<div className="footright">
          <p>made by <a rel="noreferrer" target="_blank" href="https://www.marimento.com/">Marimento</a></p>
        </div>
        */}

      </div>


    </div>
  );
});
